import { defineStore } from 'pinia'
import { IStore } from '../core/interface/IStore'
import { reactive } from 'vue'
import { EnumAuthState } from '@/contracts/system-modules/auth/enum/EnumAuthState'
import { readWorkspace } from '@/helpers/workspaceStorage'

export default defineStore('systemAuthStoreV1', {
  state: (): IStore => {
    return {
      user: reactive({
        name: '',
        uuid: '',
        deviceUuid: '',
      }),
      authorized: false,
      stage: EnumAuthState.LOGIN,
      formEnter: reactive({
        input: '',
        isWaiting: false,
        errorShow: false,
        errorMessage: '',
        isRejected: false,
        isPinStep: false,
      }),
      formRegister: reactive({
        phrase: '',
        pin: '',
        resetPin: '',
        errorShow: false,
        errorMessage: '',
      }),
      formPins: reactive({
        pin: '',
        resetPin: '',
        errorShow: false,
        errorMessage: '',
      }),
      formChangePins: reactive({
        isShown: false,
        currentPin: '',
        pin: '',
        resetPin: '',
        errorShow: false,
        errorMessage: '',
      }),
      loginRequests: [],
      workspace: readWorkspace(),
      workspaceSwitch: null,
      userKey: null,
      reset(): void {
        this.user.name = ''
        this.user.uuid = ''
        this.user.deviceUuid = ''
        this.authorized = false
        this.stage = EnumAuthState.LOGIN
        this.formEnter.isWaiting = false
        this.formEnter.isPinStep = false
        Object.assign(this.formChangePins, { isShown: false, currentPin: '', pin: '', resetPin: '', errorShow: false, errorMessage: '' })
        this.loginRequests = []
        this.workspace = readWorkspace()
        this.workspaceSwitch = null
        this.userKey = null
      },
    }
  },
})
